const adminNotificationCenter = {
  permissionDenied: "You don't have permission to send notifications.",
  sentScreen: {
    title: "Notification sent",
    deliveredPrefix: "Delivered to",
    userCount_one: "user.",
    userCount_other: "users.",
    nameColumn: "Name",
    emailColumn: "Email",
    sendAnother: "Send another",
  },
  header: {
    heading: "New notification",
    subheading: "Send an in-app message to users in your organization.",
  },
  form: {
    titleLabel: "Title",
    titlePlaceholder: "e.g. Scheduled maintenance on Friday",
    messageLabel: "Message",
    messagePlaceholder: "Write the notification body…",
    insertEmojiAriaLabel: "Insert emoji",
    characterCount: "{{count}} characters",
  },
  audience: {
    label: "Audience",
    options: {
      allOrg: {
        label: "Everyone in the organization",
        description: "All active users in your organization",
      },
      allPis: {
        label: "All Principal Investigators",
        description: "Every PI in your organization",
      },
      projectMembers: {
        label: "Project members",
        description: "Members of one or more projects you manage",
      },
      specificUsers: {
        label: "Specific users",
        description: "Hand-pick individual recipients",
      },
    },
    selectProjects: "Select projects ({{count}} selected)",
    noProjectsAvailable: "No projects available.",
    selectUsers: "Select users ({{count}} selected)",
    searchPlaceholder: "Search by name or email…",
    noUsersMatch: "No users match your search.",
  },
  recipientSummary: {
    allOrg: "Everyone in your organization",
    allPis: "All PIs and managers",
    selectProjectPrompt: "Select at least one project",
    projectsSelected_one: "Members of {{count}} project",
    projectsSelected_other: "Members of {{count}} projects",
    selectUserPrompt: "Select at least one user",
    usersSelected_one: "{{count}} selected user",
    usersSelected_other: "{{count}} selected users",
  },
  footer: {
    recipientsLabel: "Recipients:",
    sending: "Sending…",
    send: "Send notification",
  },
  errors: {
    titleAndMessageRequired: "Title and message are required.",
    projectRequired: "Select at least one project to receive this notification.",
    userRequired: "Select at least one user to receive this notification.",
    sendFailed: "Failed to send notification",
  },
};

export default adminNotificationCenter;
